function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Button from 'components/Form/Button';
import messages from '../../../messages';
import styles from '../DownloadDataModal.pcss';
const InstallBlueCableDrivers = ({ onSetComponent })=>{
    const onConnect = ()=>onSetComponent('Connect');
    const onInstall = ()=>onSetComponent('InstallingBlueCableDrivers');
    return /*#__PURE__*/ _jsxs("div", {
        className: styles.modal__content,
        children: [
            /*#__PURE__*/ _jsx("h3", {
                className: "modal__subheader ",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.installBlueCableDrivers.header))
            }),
            /*#__PURE__*/ _jsx("p", {
                className: "modal__info",
                children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.installBlueCableDrivers.info))
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.illustration,
                children: /*#__PURE__*/ _jsx("img", {
                    src: "/assets/svg/blue-cable-drivers.svg",
                    alt: ""
                })
            }),
            /*#__PURE__*/ _jsx(Button, {
                styleModifier: "primary",
                labelMessage: messages.buttons.installBlueCableDrivers,
                className: "btn--block btn--filled mb-0",
                onClick: onInstall
            }),
            /*#__PURE__*/ _jsxs("p", {
                className: "modal__info text--center d-flex align-items-center justify-content-center mt-3",
                children: [
                    /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.installBlueCableDrivers.elevatedPermissions)),
                    /*#__PURE__*/ _jsx("img", {
                        src: "/assets/img/uac-shield.png",
                        className: "ml-2",
                        alt: ""
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                className: styles.divider,
                children: /*#__PURE__*/ _jsx("span", {
                    className: styles.divider__text,
                    children: /*#__PURE__*/ _jsx(FormattedMessage, _object_spread({}, messages.infos.or))
                })
            }),
            /*#__PURE__*/ _jsx(Button, {
                styleModifier: "transparent",
                labelMessage: messages.buttons.changeDeviceType,
                className: "btn--no-size text--primary m-0",
                onClick: onConnect
            })
        ]
    });
};
export default InstallBlueCableDrivers;
